import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SubLoaderComponent } from "./sub-loader.component";

@NgModule({
  declarations: [SubLoaderComponent],
  imports: [CommonModule],
  exports: [SubLoaderComponent],
})
export class SubLoaderModule {}
